import { ChallengeTask, TaskStatus, ChallengeCampaign } from "@/types/challenges.types";

export const getMaxPoints = (task: ChallengeTask): number => {
  return parseInt(task.points) || 0;
};

export const getActiveTasks = (campaign: ChallengeCampaign, taskStatuses: TaskStatus[]): TaskStatus[] => {
  if (!campaign?.tasks || !taskStatuses) return [];

  return taskStatuses.filter((taskStatus) => {
    const task = campaign.tasks?.find((t: ChallengeTask) => t.id === taskStatus.taskGuid);
    return task && task.isEnabled !== false;
  });
};

export const consumeTaskGuidAndName = (): { taskGuid: string | null; taskName: string | null } => {
  if (typeof window === "undefined") return { taskGuid: null, taskName: null };

  try {
    const taskGuid = localStorage.getItem("taskGuid");
    const taskName = localStorage.getItem("taskName");
    return { taskGuid, taskName };
  } catch {
    return { taskGuid: null, taskName: null };
  }
};

export const getAirdropArgumentValue = (args: { name: string; value: string }[] | Record<string, string>, key: string): string | null => {
  if (!args) return null;
  
  // Handle array format
  if (Array.isArray(args)) {
    const arg = args.find((arg) => arg.name === key);
    return arg ? arg.value : null;
  }
  
  // Handle object format
  return args[key] || null;
};

